module.exports = __webpack_public_path__ + "img/55247zy.a760d9a7.png";